import { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Spinner } from "@radix-ui/themes";
import { useBankTransactionsQuery } from "@/domains/bank/hooks/useBankTransactionsQuery";
import { TransactionHistory } from "@/domains/bank/components/BankBranch/components/TransactionHistory";

function ErrorFallback({ error }: { error: Error }) {
  return <div>Error: {error.message}</div>;
}

export function BankBranchTransactionsTabContainer() {
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsQuery = useBankTransactionsQuery({
    page: currentPage,
    limit: 50,
  });

  if (transactionsQuery.isError) {
    return <div>Query error: {transactionsQuery.error.message}</div>;
  }

  return (
    <div className="h-full">
      {transactionsQuery.isLoading ? (
        <div className="flex items-center justify-center h-full">
          <Spinner className="size-6 animate-spin" />
        </div>
      ) : (
        <ErrorBoundary fallbackRender={ErrorFallback}>
          <TransactionHistory
            transactions={transactionsQuery.data}
            isRefetching={transactionsQuery.isFetching}
            page={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </ErrorBoundary>
      )}
    </div>
  );
}
